import FieldMultiselect from "../../../generic/multiselect/multiselect"
import FieldConfig from "../../../proto/field-config"
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"
import {
    ProjectAccess,
    ProjectAccessDescriptionDictionary,
    ProjectAccessLabelDictionary
} from "../../../../gd/const/project"

// Renders project access as a multiselect where the underlying model value is a single (minimal
// required) access level, but every access level that satisfies it is shown as selected/checked.
// this.options controls display order only (top to bottom in the popover) - the cascade below
// always operates on options sorted by value ascending (least to most privileged), regardless of
// display order: selecting a value also selects every more-privileged value above it (see
// toggleOptionValue), deselecting a value also deselects every less-privileged value below it,
// and getViewValue() expands the single stored value into every value that satisfies it. Once
// every option ends up deselected the field falls back to its placeholder text (no dedicated
// "no restriction" option/checkbox).
export default class FieldProjectAccessMultiselect extends FieldMultiselect {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel      = "Project Access"
        this.typeGroup      = GROUP_INFO

        this.noValueOption  = false

        this.placeholder    = _.get(config, "placeholder", "No restriction")

        this.options        = _.get(config, "options", [
            {value: ProjectAccess.FULL,      label: ProjectAccessLabelDictionary[ProjectAccess.FULL],     description: ProjectAccessDescriptionDictionary[ProjectAccess.FULL]},
            {value: ProjectAccess.STANDARD,  label: ProjectAccessLabelDictionary[ProjectAccess.STANDARD], description: ProjectAccessDescriptionDictionary[ProjectAccess.STANDARD]},
            {value: ProjectAccess.LIMITED,   label: ProjectAccessLabelDictionary[ProjectAccess.LIMITED],  description: ProjectAccessDescriptionDictionary[ProjectAccess.LIMITED]},
        ])

        this.components.PopoverMenuMore = null
    }

    // options ordered by value ascending (least to most privileged) - used for cascade math,
    // independent of this.options display order
    _optionsByPrivilege():Option[] {
        return _.sortBy(this.options || [], 'value')
    }

    // model stores a single (minimal required) access value - expand it here into every access
    // level that satisfies it, so all of them show as selected in the field
    getViewValue(model:any):any[] | null {
        const storedValue = _.get(model, this.fieldId, null)

        if (_.isNil(storedValue)) {
            return null
        }

        const options = this._optionsByPrivilege()
        const index   = _.findIndex(options, option=>option.value === storedValue)

        if (index === -1) {
            return null
        }

        return _.map(options.slice(index), option=>option.value)
    }

    // Called by FieldMultiselect_FormComponent instead of the default plain array toggle.
    // Selecting a value also selects every more-privileged value above it (cascade up).
    // Deselecting a value also deselects every less-privileged value below it (cascade down).
    toggleOptionValue(currentOptions:any[], value:any):any[] {
        const orderedValues = _.map(this._optionsByPrivilege(), option=>option.value)
        const clickedIndex  = orderedValues.indexOf(value)

        if (clickedIndex === -1) {
            return currentOptions || []
        }

        const current    = currentOptions || []
        const isSelected = current.includes(value)

        if (isSelected) {
            return _.filter(current, v=>orderedValues.indexOf(v) > clickedIndex)
        } else {
            return _.union(current, orderedValues.slice(clickedIndex))
        }
    }

}
